module.exports = __webpack_public_path__ + "static/media/MHeiHK-Light.aef933e8.svg";